import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-cream relative overflow-hidden" data-id="element-29">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-sage-400/5 rounded-full blur-3xl -z-10" data-id="element-30" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-32">
          <span className="inline-block py-1 px-3 rounded-full bg-coral-500/10 text-coral-600 font-semibold text-sm tracking-wide mb-6 uppercase" data-id="element-33">
            The 10-Minute Somatic Protocol
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.15] tracking-tight mb-8 text-charcoal-800" data-id="element-34">
            How to Melt Your "Cortisol Belly" and Reclaim Your Energy in 7 Days{' '}
            <span className="italic font-light text-sage-600" data-id="element-35">
              Without Restrictive Diets
            </span>{' '}
            or Exhausting Cardio.
          </h1>

          <h3 className="text-xl sm:text-2xl text-charcoal-700 font-display italic mb-10 max-w-3xl mx-auto" data-id="element-36">
            Specifically designed for busy women stuck in the "Wired but Tired"
            loop.
          </h3>

          <motion.img src="https://cdn.magicpatterns.com/uploads/a4cuGvgfZDWzyrzckcnfDZ/mockup.png" alt="The Cortisol Code — complete bundle with guide, journals, workbooks, video library, and shopping list app" className="w-full max-w-3xl mx-auto rounded-2xl shadow-2xl mb-12" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-37" />

          <p className="text-lg text-charcoal-700/80 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-38">
            Stop fighting your body and start closing the "Stress Loop." Finally
            quiet the brain fog, end the 3 PM crashes, and wake up feeling like
            yourself again.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-39">
            <Button variant="urgent" size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-40">
              YES! RESET MY CORTISOL NOW FOR $27
            </Button>
          </div>
          <p className="mt-4 text-sm text-charcoal-700/60" data-id="element-41">
            Immediate Digital Access • One-time payment • No subscriptions
          </p>
        </motion.div>
      </div>
    </section>;
}